import Cookies from 'js-cookie'
import * as types from './mutation-types'
import api from '../api'
import User from '@/class/User'
import { getField, updateField } from 'vuex-map-fields'

export const state = {
	signIn: {
		email: '',
		password: ''
	},

	forgotPassword: {
		email: ''
	},

	changePassword: {
		password: '',
		confirmPassword: ''
	},

	error: '',
	loading: false,
	user: null,
	apiToken: Cookies.get('token') || null,
	isPasswordReset: false,
	passwordResetError: '',
	requestStatus: '',

	passwordResetId: null,
	isPasswordResetSuccess: false,
	passwordResetErrors: []
}

export const mutations = {
	updateField,

	[types.FETCH_USER_SUCCESS] (state, user) {
		state.user = new User(user)
		Object.freeze(state.user)
	},

	[types.FETCH_USER_FAILURE] (state) {
		state.user = { token: null }
		Cookies.remove('token')
	},

	[types.SIGN_IN] (state) {
		state.loading = true
	},

	async [types.SIGN_IN_SUCCESS] (state, { data, router }) {
		state.loading = false
		Cookies.set('token', data.api_token, { expires: 36500 })
		state.user = new User(data)
		Object.freeze(state.user)
		router.go()
	},

	[types.SIGN_IN_FAIL] (state, payload) {
		if (payload['0']) {
			state.error = payload['0']
		}

		if (payload['email']) {
			state.error = payload.email[0]
		}

		if (payload['password']) {
			state.error = payload.password[0]
		}

		state.loading = false
	},

	[types.REQUEST_RESET_SUCCESS] (state, { status, router }) {
		state.loading = false
		state.requestStatus = status

		state.forgotPassword = {
			email: ''
		}
	},

	[types.REQUEST_RESET_FAILURE] (state, payload) {
		state.loading = false
		state.requestStatus = payload
	},

	[types.PASSWORD_RESET] (state) {
		state.loading = true
	},

	[types.PASSWORD_RESET_SUCCESS] (state, router) {
		state.loading = false
		state.error = ''
		state.isPasswordResetSuccess = true
		router.push('/')
	},

	[types.PASSWORD_RESET_FAILURE] (state, payload) {
		state.loading = false
		state.passwordResetErrors = payload
	},

	[types.SET_IS_RESETTING] (state, { payload, router }) {
		state.isPasswordReset = true
		state.loading = false
		state.passwordResetId = payload.id

		router.push('/change-password')
	},

	LOG_OUT (state) {
		Cookies.remove('token')
		state.user = null
		state.apiToken = null

		location.reload()
	},

	clearError (state) {
		state.error = {}
	}
}

export const actions = {
	async fetchUser ({ commit }, payload) {
		const { data, status } = await api('post', 'authenticate/fetch-user')

		if (status) {
			commit(types.FETCH_USER_SUCCESS, data.data)
			return
		}

		commit(types.FETCH_USER_FAILURE)
	},

	async login ({ commit, dispatch }, payload) {
		commit(types.SIGN_IN)

		const { data, status } = await api('post', 'authenticate/login', payload.form)

		if (status) {
			if (data.data.is_temporary === 1) {
				commit(types.SET_IS_RESETTING, { payload: data.data, router: payload.router })
				return
			}

			const payloadData = {
				data: data.data,
				router: payload.router
			}

			await commit(types.SIGN_IN_SUCCESS, payloadData)

			return
		}

		commit(types.SIGN_IN_FAIL, data.errors)
	},

	async requestReset ({ commit }, payload) {
		state.loading = true

		const { data, status } = await api('post', 'authenticate/forgot-password', payload.form)

		if (status && data.status === 200) {
			const payloadData = {
				status: data.status,
				router: payload.router
			}

			commit(types.REQUEST_RESET_SUCCESS, payloadData)

			return
		}

		if (data.status === 204) {
			state.error = data.message

			state.loading = false
			return
		}

		commit(types.REQUEST_RESET_FAILURE, data)
	},

	async changePassword ({ commit }, payload) {
		commit(types.PASSWORD_RESET)

		const { data, status } = await api('post', 'authenticate/change-password', payload.form)

		if (status) {
			commit(types.PASSWORD_RESET_SUCCESS, payload.router)
			return
		}

		commit(types.PASSWORD_RESET_FAILURE, data.errors.password)
	}
}

export const getters = {
	getField,
	getLogInError: state => state.error,
	getLoading: state => state.loading,

	getLoggedInState: state => state.user !== null,

	getUser: state => state.user,
	getToken: state => state.apiToken,

	getChangePassword: state => state.isPasswordReset,
	getRequestStatus: state => state.requestStatus,
	getPasswordResetId: state => state.passwordResetId,

	getPasswordResetError: state => state.passwordResetError
}
